module.exports = __webpack_public_path__ + "img/jumpseller_1.3f23d8c1.png";